module.exports = __webpack_public_path__ + "img/brand(7).5e687f76.png";